export var FileUploadNamespace;
(function (FileUploadNamespace) {
    FileUploadNamespace["HOMEWORK"] = "homework";
    FileUploadNamespace["CHAT_FILE"] = "chat-file";
    FileUploadNamespace["LESSON_MODULE"] = "lesson-module";
    FileUploadNamespace["LESSON"] = "lesson";
    FileUploadNamespace["WEBINAR"] = "webinar";
})(FileUploadNamespace || (FileUploadNamespace = {}));
